export default {
  within: '¹ Delivery within London: Within 2 hours - Monday-Friday 09:00-20:00, Saturday 09:00-17:00',
  outside: '² Delivery outside of London: Our cut off for next day delivery is 16:45 Monday-Sunday. Any prescription order payments after this time will be fulfilled by the pharmacy the following day and take an extra working day to arrive',
};
